import '../static/utf8-php/ueditor.config.js'
import '../static/utf8-php/ueditor.all.min.js'

import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import VueRouter from 'vue-router'
import routes from './routes'
import axios from 'axios';
import { post, get, del, put } from './common/js/http';
import global_ from './common/js/tools';
import MCF from '@/common/js/MCF';
import 'element-ui/lib/theme-chalk/index.css';
import NutUI from '@nutui/nutui'
import '@nutui/nutui/dist/nutui.min.css'
import '@wangeditor/editor/dist/css/style.css'

Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$del = del;
Vue.prototype.$put = put;
Vue.prototype.$Tools = global_;
const MyPcNodeObj = MCF.MyPcNodes();
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(MyPcNodeObj);
NutUI.install(Vue)

Vue.directive('throttle', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true;
        el.classList.add('is-disabled');
        setTimeout(() => {
          el.disabled = false;
          el.classList.remove('is-disabled');
        }, binding.value || 2000);
      }
    });
  }
});

const router = new VueRouter({
	routes
})

router.beforeEach((to, from, next) => {
    let user = sessionStorage.getItem('USER-TOKEN');
    const noAuthPaths = [
        '/login',
        '/AdminLogin', 
        '/MobileLogin',
        '/Signature/:id'
    ];
    const isNoAuthPath = noAuthPaths.some(path => {
        if (path.includes(':id')) {
            return to.path.startsWith('/Signature/');
        }
        return to.path === path;
    });
    if (isNoAuthPath) {
        if (to.path === '/login' || to.path === '/AdminLogin' || to.path === '/MobileLogin') {
            sessionStorage.clear();
        }
        next();
    } else if (!user || to.path === '/') {
        if (localStorage.getItem('g') == 1) {
            next({ path: '/AdminLogin' });
        } else {
            next({ path: '/login' });
        }
    } else {
        next();
    }
})

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')